import { Chain } from '@ankr.com/chains-list';
import { useAppKitAccount } from '@reown/appkit/react';

import { Dialog } from 'uiKit/Dialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { AddToWalletButton } from './components/AddToWalletButton';
import { ChainInfo } from '../ChainInfo';
import { ChainSelectors } from './components/ChainSelectors';
import { ConnectWalletButton } from './components/ConnectWalletButton';
import { addNetworkDialogTranslation } from './translation';
import { useAddNetworkDialogStyles } from './useAddNetworkDialogStyles';

interface AddNetworkDialogProps {
  chain: Chain;
  isOpened: boolean;
  onClose: () => void;
  projectSelector?: React.ReactNode;
  isChainSelectorHidden?: boolean;
}

const onDialogClick = (event: React.MouseEvent<HTMLElement>) =>
  event.stopPropagation();

export const AddNetworkDialog = ({
  chain,
  isChainSelectorHidden,
  isOpened,
  onClose,
  projectSelector,
}: AddNetworkDialogProps) => {
  const { isConnected } = useAppKitAccount();

  const { keys, t } = useTranslation(addNetworkDialogTranslation);

  const { classes } = useAddNetworkDialogStyles();

  return (
    <Dialog
      onClick={onDialogClick}
      onClose={onClose}
      open={isOpened}
      paperClassName={classes.paper}
      shouldStopPropagationOnClose
      title={t(keys.addNetworkToWallet)}
    >
      {projectSelector}
      <ChainInfo chain={chain} />
      {!isChainSelectorHidden && <ChainSelectors />}
      {isConnected ? (
        <AddToWalletButton chain={chain} />
      ) : (
        <ConnectWalletButton />
      )}
    </Dialog>
  );
};
